export default __webpack_public_path__ + "static/media/IMG-20241005-WA0054.15cee7f6.jpg";